module.exports = __webpack_public_path__ + "static/media/arboretum.56a5eafb.jpg";